export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/news-1.06570fb1-fd6a04.png";